<template>
<div class="container p-4">
    <div class="form-group col-md-12">


        <div class="row">
            <div class="col-md-6">
                <img
                    :src="image.src"
                    ref="canvas"
                    id="canvas"
                    class="mx-auto"
                    v-on:click="setStartingPoint"
                    style="max-width:100%;max-height:300px;"
                />
            </div>

            <div class="col-md-6" v-if="image">
                <table class="table table-dark">
                    <thead class="thead-dark">
                        <th>Point</th>
                        <th>X</th>
                        <th>Y</th>
                        <th class="th-fit"></th>
                    </thead>
                    <tbody>
                        <tr v-for="(member, index) in startingpoints">
                            <td>{{ index }}</td>
                            <td>{{ member.left }}</td>
                            <td>{{ member.top }}</td>
                            <td>
                                <i
                                    class="fa fa-times text-danger"
                                    @click="removeStartingpoint(index)"
                                ></i>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
    </div>
    </div>
</template>

<script>
export default {
    props: ["image", "startingpoints"],
    components: {},
    data() {
        return {};
    },
    methods: {
        setStartingPoint: function(event) {
            this.counter++;
            if (event.offsetX && event.offsetY) {
                this.startingpoints.push({
                    left: Math.round(
                        (event.offsetX / this.$refs.canvas.clientWidth) *
                            this.$refs.canvas.naturalWidth
                    ),
                    top: Math.round(
                        (event.offsetY / this.$refs.canvas.clientHeight) *
                            this.$refs.canvas.naturalHeight
                    )
                });
            }
        },
        removeStartingpoint(index) {
            this.startingpoints.splice(index, 1);
        }
    }
};
</script>
